export function objectToFormData(formData, object, prefix) {
  for (const property in object) {
    if (Object.prototype.hasOwnProperty.call(object, property)) {
      if (object[property] !== null && object[property] !== undefined) {
        formData.append(`${prefix || ''}${property}`, object[property]);
      }
    }
  }
}